<!-- Desktop toggle (hidden on mobile) -->
<div
  [ngClass]="{
    'justify-center': effectiveIsCollapsed(),
    'justify-end': !effectiveIsCollapsed()
  }"
  class="hidden md:flex ml-[24px] mr-[24px] mt-[16px] mb-4 xlplus:mt-[32px]"
>
  @if (!isCollapsed()) {
  <svg
    class="w-[16px] h-[16px] xlplus:w-[20px] xlplus:h-[20px] cursor-pointer"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    (click)="toggleSidebar()"
  >
    <path
      d="M17 17L1 1M17 1L1 17"
      stroke="black"
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
  } @else {
  <svg
    class="w-[16px] h-[16px] xlplus:w-[20px] xlplus:h-[20px] cursor-pointer"
    width="18"
    height="12"
    viewBox="0 0 18 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    (click)="toggleSidebar()"
  >
    <path d="M0 12H18V10H0V12ZM0 7H18V5H0V7ZM0 0V2H18V0H0Z" fill="black" />
  </svg>
  }
</div>

<!-- Mobile close button (visible only on mobile when sidebar is open) -->
<div class="flex md:hidden justify-end ml-[24px] mr-[24px] mt-[16px] mb-4">
  <svg
    class="w-[20px] h-[20px] cursor-pointer"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    (click)="closeMobileSidebar()"
  >
    <path
      d="M17 17L1 1M17 1L1 17"
      stroke="black"
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
</div>

<div class="basis-1/10 flex justify-center items-center w-full mx-auto">
  <div class="w-[40px] h-[36.7px] xlplus:w-[50px] xlplus:h-[47.6px] relative">
    <img
      ngSrc="/common/yyc_logo.webp"
      alt="YYC Logo"
      fill
      priority
      (load)="isLoadingYYCLogo = false"
      [style.visibility]="isLoadingYYCLogo ? 'hidden' : 'visible'"
    />
  </div>
  <p
    [ngClass]="{
      'opacity-100 w-auto': !effectiveIsCollapsed(),
      'opacity-0 w-0 overflow-hidden': effectiveIsCollapsed()
    }"
    class="transition-all duration-800 font-inter font-extrabold text-15[px] xlplus:text-[20px] ml-1 my-auto"
  >
    <span class="mr-1 text-taxpod-blue">MBRS</span>TOOL
  </p>
</div>

<div class="basis-9/10 flex flex-col justify-between mt-6">
  <div>
    @if (canUseConversions()) {
    <a
      routerLink="/mbrs/dashboard"
      routerLinkActive="bg-taxpod-blue text-white"
      class="flex p-3 text-black rounded-md"
      [ngClass]="
        effectiveIsCollapsed()
          ? 'justify-center ml-[15px] mr-[15px]'
          : 'gap-2 ml-[24px] mr-[24px]'
      "
      (click)="closeMobileSidebar()"
    >
      <svg
        class="w-[20px] h-[21px] xlplus:w-[24px] xlplus:h-[25px]"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.02227 13.5006H5.67092C5.22689 13.5031 4.80191 13.6813 4.48882 13.9961C4.17573 14.311 3.99999 14.737 4 15.181V18.5324C3.99977 18.7519 4.04284 18.9692 4.12673 19.1721C4.21062 19.3749 4.33369 19.5592 4.48889 19.7144C4.6441 19.8696 4.82839 19.9927 5.03122 20.0766C5.23405 20.1605 5.45143 20.2035 5.67092 20.2033H9.02227C9.46636 20.2038 9.89253 20.0281 10.2074 19.7149C10.5222 19.4017 10.7 18.9765 10.7018 18.5324V15.181C10.7021 14.9604 10.6588 14.7419 10.5745 14.538C10.4901 14.3341 10.3664 14.1489 10.2104 13.9929C10.0544 13.8369 9.86916 13.7132 9.66528 13.6288C9.46141 13.5445 9.2429 13.5012 9.02227 13.5015M9.02227 4.20329H5.67092C5.45143 4.20307 5.23405 4.24613 5.03122 4.33002C4.82839 4.41391 4.6441 4.53698 4.48889 4.69219C4.33369 4.84739 4.21062 5.03168 4.12673 5.23451C4.04284 5.43734 3.99977 5.65472 4 5.87421V9.22556C3.99954 9.66966 4.17516 10.0958 4.48837 10.4107C4.80158 10.7255 5.22683 10.9033 5.67092 10.9051H9.02227C9.2429 10.9054 9.46141 10.8621 9.66528 10.7777C9.86916 10.6934 10.0544 10.5697 10.2104 10.4137C10.3664 10.2577 10.4901 10.0725 10.5745 9.86858C10.6588 9.6647 10.7021 9.44619 10.7018 9.22556V5.87421C10.7 5.43012 10.5222 5.00487 10.2074 4.69166C9.89253 4.37845 9.46636 4.20283 9.02227 4.20329ZM18.3291 4.20329H14.9777C14.5336 4.20283 14.1075 4.37845 13.7926 4.69166C13.4778 5.00487 13.3 5.43012 13.2982 5.87421V9.22556C13.2984 9.67094 13.4754 10.098 13.7903 10.4129C14.1053 10.7279 14.5324 10.9049 14.9777 10.9051H18.3291C18.7732 10.9033 19.1984 10.7255 19.5116 10.4107C19.8248 10.0958 20.0005 9.66966 20 9.22556V5.87421C20.0002 5.65472 19.9572 5.43734 19.8733 5.23451C19.7894 5.03168 19.6663 4.84739 19.5111 4.69219C19.3559 4.53698 19.1716 4.41391 18.9688 4.33002C18.766 4.24613 18.5486 4.20307 18.3291 4.20329Z"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16.6427 13.7747V19.9291M13.5715 16.8588H19.7259"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
      </svg>

      <div
        [ngClass]="{
          'opacity-100 w-auto': !effectiveIsCollapsed(),
          'opacity-0 w-0 overflow-hidden': effectiveIsCollapsed()
        }"
        class="text-base xlplus:text-lg leading-[21.78px] my-auto font-semibold whitespace-nowrap"
      >
        My Dashboard
      </div>
    </a>
    <a
      routerLink="/mbrs/xbrl-files"
      routerLinkActive="bg-taxpod-blue text-white"
      class="flex p-3 text-black rounded-md"
      [ngClass]="
        effectiveIsCollapsed()
          ? 'justify-center ml-[15px] mr-[15px]'
          : 'gap-2 ml-[24px] mr-[24px]'
      "
      (click)="closeMobileSidebar()"
    >
      <svg
        class="w-[20px] h-[21px] xlplus:w-[24px] xlplus:h-[25px]"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.736 7.40331L11.336 9.00331H18.4V17.0033H5.6V7.40331H9.736ZM10.4 5.80331H5.6C4.72 5.80331 4.008 6.52331 4.008 7.40331L4 17.0033C4 17.8833 4.72 18.6033 5.6 18.6033H18.4C19.28 18.6033 20 17.8833 20 17.0033V9.00331C20 8.12331 19.28 7.40331 18.4 7.40331H12L10.4 5.80331Z"
          fill="currentColor"
        />
      </svg>
      <div
        [ngClass]="{
          'opacity-100 w-auto': !effectiveIsCollapsed(),
          'opacity-0 w-0 overflow-hidden': effectiveIsCollapsed()
        }"
        class="text-base xlplus:text-lg font-semibold whitespace-nowrap"
      >
        XBRL Files
      </div>
    </a>
    }
    <!-- <a
      routerLink="/mbrs/filing"
      routerLinkActive="bg-taxpod-blue text-white"
      class="flex p-3 text-black rounded-md"
      [ngClass]="
        isCollapsed()
          ? 'justify-center ml-[15px] mr-[15px]'
          : 'gap-2 ml-[24px] mr-[24px]'
      "
    >
      <svg
        class="w-[20px] h-[21px] xlplus:w-[24px] xlplus:h-[25px]"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14 2V8H20M16 13H8M16 17H8M10 9H8"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <div
        [ngClass]="{
          'opacity-100 w-auto': !isCollapsed(),
          'opacity-0 w-0 overflow-hidden': isCollapsed()
        }"
        class="text-base xlplus:text-lg font-semibold whitespace-nowrap"
      >
        MBRS Filing Forms
      </div>
    </a> -->
    @if (canManageUsers()) {
    <a
      routerLink="/mbrs/user-management"
      routerLinkActive="bg-taxpod-blue text-white"
      class="flex p-3 text-black rounded-md"
      [ngClass]="
        effectiveIsCollapsed()
          ? 'justify-center ml-[15px] mr-[15px]'
          : 'gap-2 ml-[24px] mr-[24px]'
      "
      (click)="closeMobileSidebar()"
    >
      <svg
        class="ml-1 w-[20px] h-[21px] xlplus:w-[24px] xlplus:h-[25px]"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2 19.7031V17.9253C2 16.9824 2.3746 16.078 3.0414 15.4112C3.70819 14.7444 4.61256 14.3698 5.55556 14.3698H9.11111C10.0541 14.3698 10.9585 14.7444 11.6253 15.4112C12.2921 16.078 12.6667 16.9824 12.6667 17.9253V19.7031M13.5556 3.81868C14.3204 4.0145 14.9983 4.4593 15.4823 5.08296C15.9664 5.70661 16.2292 6.47364 16.2292 7.26313C16.2292 8.05261 15.9664 8.81964 15.4823 9.44329C14.9983 10.0669 14.3204 10.5117 13.5556 10.7076M18 19.7031V17.9253C17.9955 17.1406 17.7315 16.3794 17.2491 15.7604C16.7668 15.1414 16.0932 14.6993 15.3333 14.5031M3.77778 7.25868C3.77778 8.20167 4.15238 9.10604 4.81918 9.77284C5.48597 10.4396 6.39034 10.8142 7.33333 10.8142C8.27633 10.8142 9.1807 10.4396 9.84749 9.77284C10.5143 9.10604 10.8889 8.20167 10.8889 7.25868C10.8889 6.31569 10.5143 5.41132 9.84749 4.74452C9.1807 4.07773 8.27633 3.70313 7.33333 3.70312C6.39034 3.70313 5.48597 4.07773 4.81918 4.74452C4.15238 5.41132 3.77778 6.31569 3.77778 7.25868Z"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div
        [ngClass]="{
          'opacity-100 w-auto': !effectiveIsCollapsed(),
          'opacity-0 w-0 overflow-hidden': effectiveIsCollapsed()
        }"
        class="text-base xlplus:text-lg font-semibold whitespace-nowrap"
      >
        User Management
      </div>
    </a>
    }
  </div>
  <div
    [class.opacity-0]="effectiveIsCollapsed()"
    [class.opacity-100]="!effectiveIsCollapsed()"
    [class.pointer-events-none]="effectiveIsCollapsed()"
    class="transition-opacity duration-300 ease-in-out ml-[24px] mr-[24px] font-lato font-normal text-[10px] xlplus:text-xs mb-[22px] text-taxpod-gray-light"
  >
    <p>Copyright &copy; {{ currentYear }} YYC Holdings</p>
    <p>Sdn. Bhd.</p>
  </div>
</div>
